import { createClient } from '@supabase/supabase-js';
import { EMAIL_CONFIRM_NAV_FLAG } from '../constants/authRedirect';
import { envConfig } from '../env';

/** Before createClient reads the fragment, stash intent so SPA can navigate to `/login?confirmed=1` later. */
function snapshotSignupConfirmLanding(): void {
  if (typeof window === 'undefined') return;
  const hash = window.location.hash.replace(/^#/, '');
  if (hash) {
    const hp = new URLSearchParams(hash);
    const type = hp.get('type');
    if (type === 'signup' || type === 'email') {
      sessionStorage.setItem(EMAIL_CONFIRM_NAV_FLAG, '1');
      return;
    }
  }
  const sp = new URLSearchParams(window.location.search);
  if (sp.get('code') && window.location.pathname === '/') {
    sessionStorage.setItem(EMAIL_CONFIRM_NAV_FLAG, '1');
  }
}

snapshotSignupConfirmLanding();

/** Supabase anon / publishable key from root `NEXT_PUBLIC_*` or `client` `VITE_*` (vite.config bridges both). */
const url = envConfig.supabaseUrl?.trim();
const anon = envConfig.supabaseAnonKey?.trim();

if (typeof window !== 'undefined' && (!url || !anon)) {
  console.error(
    '[Supabase] Missing VITE_SUPABASE_URL / NEXT_PUBLIC_SUPABASE_URL or anon/publishable key. Add them to `.env` at repo root, then restart `npm run dev`.'
  );
}

/** Anonymous Supabase client — session persists to localStorage (`persistSession: true`). */
export const supabase = createClient(
  url ?? 'https://invalid.local',
  anon ?? 'missing-key'
);
